import React from "react";
import {Button, CircularProgress} from "@material-ui/core";

export interface RefreshWithFeedbackButtonProps {
  isLoading: boolean;
  handleRefresh: () => void;
  reverse?: boolean;
}

export const RefreshWithFeedbackButton = React.forwardRef<
  HTMLButtonElement,
  RefreshWithFeedbackButtonProps
>(({isLoading, handleRefresh, reverse}, ref) => {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        flexDirection: reverse ? "row-reverse" : "row",
        gap: "0.5em",
      }}
    >
      <Button
        ref={ref}
        variant="contained"
        color="primary"
        onClick={handleRefresh}
      >
        Refresh
      </Button>
      {isLoading && <CircularProgress size={20} />}
    </div>
  );
});

RefreshWithFeedbackButton.displayName = "RefreshWithFeedbackButton";
